import { useTranslation } from 'react-i18next'

import { type Actor } from '@campai/lib-common/entities'

import { useActorCurrentUserId } from './ActorProvider'

export const ActorName = ({
    actor,
    className,
    showCurrentUserAsYou = true,
}: {
    actor: Actor
    className?: string
    showCurrentUserAsYou?: boolean
}) => {
    const { t } = useTranslation()
    const currentUserId = useActorCurrentUserId()
    let name = actor.name

    if (actor.type === 'user') {
        if (actor.userId === '') {
            name = t('components.actorName.deletedUser')
        } else if (showCurrentUserAsYou && actor.userId === currentUserId) {
            name = t('components.actorName.currentUser')
        }
    }

    if (actor.type === 'contact' && actor.contact === null) {
        name = t('components.actorName.deletedContact')
    }

    return <span className={className}>{name}</span>
}
